export const PROJECTS_SUCCESS = 'PROJECTS_SUCCESS';
export const GET_PROJECTS = 'GET_PROJECTS';